import React, { useEffect, useState, useContext } from "react";
import "moment/locale/th";
import { useNavigate } from "react-router";
import * as adminApi from "../../../../service/adminApi";
import { CurrentUserContext } from "../../../../App";
import PageHeaderV2 from "../../../pageheaderV2/PageHeaderV2";
import TableSearchV1 from "../../../tableV1/tableSearchV1";
import { RedirectCode400 } from "../../../RedirectCode400";
import { FaEye, FaEdit, FaTrash } from "react-icons/fa";
import format from "date-fns/format";
import Select from "../../../material/select/SelectV2";
import { useLocation } from "react-router";

function MenuList() {
  const { setIsMessage } = useContext(CurrentUserContext);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [guidelineList, setGuidelineList] = useState([]);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [totalGuideline, setTotalGuideline] = useState(null);
  const [sortBy, setSortBy] = useState({ id: "", desc: false });

  const [filters, setFilters] = useState({
    name: "",
    "create_date.date": "",
    "update_date.date": "",
  });
  const location = useLocation();
  const [role, setRole] = useState("");

  useEffect(() => {
    const savedRole = localStorage.getItem("role");
    if (savedRole) {
      setRole(savedRole);
    } else {
      localStorage.setItem("role", "PUBLIC");
    }
  }, []);

  useEffect(() => {
    const currentPath = location.pathname;

    return () => {
      if (currentPath === "/admin/management/menu/menu-list") {
        localStorage.setItem("role", "PUBLIC");
      }
    };
  }, [location]);

  const handleRoleChange = (newRoles) => {
    localStorage.setItem("role", newRoles);
    setRole(newRoles);
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    fetchGuidelines();
  }, [page, filters, role, sortBy]);

  const fetchGuidelines = async () => {
    setLoading(true);
    let res = await adminApi.getMenuList(
      page,
      10,
      role,
      filters.name,
      formatDate(filters["create_date.date"]),
      formatDate(filters["update_date.date"]),
      sortBy.id,
      sortBy.id ? (sortBy.desc ? "desc" : "asc") : "",
    );
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setGuidelineList(res["data"]["menu_list"]);
        setMaxPage(Math.ceil(res["data"]["amount"] / 10));
        setTotalGuideline(res["data"]["amount"]);
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const removeMenu = async (item) => {
    if (!window.confirm(`คุณต้องการลบ ${item["name"]} ใช่หรือไม่`)) {
      return;
    }
    setLoading(true);
    let res = await adminApi.removeMenu(item["menu_id"]);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        fetchGuidelines();
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
      setGuidelineList([]);
    }
  };

  const role_list = [
    { name: "ทั่วไป", value: "PUBLIC" },
    { name: "ประชาชนทั่วไป", value: "PATIENT" },
    { name: "แพทย์/เภสัช", value: "MEDICAL_PERSONNEL" },
    { name: "ผู้ดูแลห้องปฏิบัติการ", value: "LABORATORY_ADMIN" },
    { name: "ผู้ปฏิบัติการในห้องปฏิบัติการ", value: "LABORATORY_PERSONNEL" },
    { name: "เจ้าหน้าที่โรงพยาบาล", value: "HOSPITAL_PERSONNEL" },
    { name: "ผู้บริหาร", value: "EXECUTIVE" },
    { name: "โรงพยาบาล", value: "HOSPITAL" },
    { name: "ผู้ดูแลระบบ", value: "ADMIN" },
  ];

  const formatDate = (date) => {
    if (!date) return "";
    return format(date, "yyyy-MM-dd");
  };

  const formatDateThai = (date) => {
    const monthsThai = [
      "ม.ค.",
      "ก.พ.",
      "มี.ค.",
      "เม.ย.",
      "พ.ค.",
      "มิ.ย.",
      "ก.ค.",
      "ส.ค.",
      "ก.ย.",
      "ต.ค.",
      "พ.ย.",
      "ธ.ค.",
    ];
    const [year, month, day] = date.split("-");
    const formattedDate = `${parseInt(day)} ${
      monthsThai[parseInt(month) - 1]
    } ${year}`;
    return formattedDate;
  };

  const handleSortChange = (id, desc) => {
    setPage(1);
    setSortBy({ id, desc });
  };

  const columns = [
    {
      Header: "No.",
      accessor: "id",
      Filter: "#",
    },
    {
      Header: "หัวข้อ",
      accessor: "name",
      Filter: "text",
    },
    {
      Header: "วันที่สร้าง",
      accessor: "create_date.date",
      Cell: ({ row }) => {
        const createdDate =
          row.original.create_date && row.original.create_date.date
            ? row.original.create_date.date
            : null;
        return createdDate ? formatDateThai(createdDate) : "-";
      },
      Filter: "date",
    },
    {
      Header: "วันที่แก้ไข",
      accessor: "update_date.date",
      Cell: ({ row }) => {
        const updatedDate =
          row.original.updated_date && row.original.updated_date.date
            ? row.original.updated_date.date
            : null;
        return updatedDate ? formatDateThai(updatedDate) : "-";
      },
      Filter: "date",
    },
    {
      Header: "#",
      disableSortBy: true,
      accessor: "actions",
      Cell: ({ row }) => {
        const i = row.original;

        return (
          <div className="flex flex-row justify-center items-center gap-[6px]">
            <div
              className="flex justify-center items-center h-[30px] p-2 rounded-[5px] cursor-pointer"
              style={{ background: "#AFEBE3 0% 0% no-repeat padding-box" }}
              onClick={() => {
                navigate("/admin/management/menu/edit-menu", {
                  state: {
                    type: "menu",
                    id: i["menu_id"],
                    name: i["name"],
                    url: i["link"],
                    external: i["external"],
                    active: i["active"],
                    parent_id: i["parent_id"],
                    role: i["role"],
                    weight: i["weight"],
                  },
                });
              }}
            >
              <FaEdit className="text-[#00917E] h-[14px]" />
            </div>
            <button
              className="flex justify-center items-center h-[30px] p-2 rounded-[5px] cursor-pointer"
              style={{ background: "#FCD8DB 0% 0% no-repeat padding-box" }}
              onClick={() => removeMenu(i)}
            >
              <FaTrash className="text-[#D32736] h-[14px]" />
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <div>
      <div className="mt-[60px]"></div>
      <div>
        <PageHeaderV2 titlename={"เมนูทั้งหมด"} />
        <div className="flex flex-row items-center justify-start gap-[10px] mb-[10px]">
          <div className="flex flex-col text-[16px] font-['Prompt'] w-full">
            <div className="">
              <Select
                value={role}
                list={role_list}
                setValue={handleRoleChange}
                placeholder="เลือกสถานะ"
                className="cursor-pointer"
              />
            </div>
          </div>
        </div>
        <TableSearchV1
          columns={columns}
          data={guidelineList}
          filters={filters}
          setFilters={setFilters}
          loading={loading}
          total={totalGuideline}
          page={page}
          maxPage={maxPage}
          setPage={setPage}
          sortBy={sortBy}
          onSortChange={handleSortChange}
          noDataComponent={<div className="w-full text-left">ไม่พบข้อมูล</div>}
        />
      </div>
    </div>
  );
}

export default MenuList;
